import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { CustomModalProvider } from './components/modal/custom-modal-provider';
import { BrowserRouter } from 'react-router-dom';
import { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <SkeletonTheme baseColor="#e2e4eb" highlightColor="rgb(240, 240, 240)" borderRadius={10}>
      <CustomModalProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </CustomModalProvider>
    </SkeletonTheme>
  </React.StrictMode>
);

reportWebVitals();
